import React, {useState} from 'react';
import {Button, Layout, Spin} from "antd";
import WxwAccountList from "./wxwAccountList";
import ConversationList from "./conversationList";
import ChatRoom from "./chatRoom";
import ChatSider from "./chatSider";
import {MenuFoldOutlined, MenuUnfoldOutlined, RedoOutlined} from "@ant-design/icons";
import {withRouter} from "react-router-dom"
import Util from "../public/utils";
import io from 'socket.io-client'
import {IMMessageType} from "../public/mtype";
import CloudApi from "../cloud/cloud_api";
import Message from "../common/message";
import empty_chat from "../im/image/chat/empty_chat.png"
import imBlank from "../im/image/chat/imBlank.png"
import ImLogin from "./common/login/imLogin";
import TopEdit from "./common/topEdit/topEdit";
import MyNotify from "../public/myNotify";
import IconAccountHelp from "../../iconfont/account/help";
import IconAccountExit from "../../iconfont/account/exit";
import CorpApi from "../public/corp_api";
import {Path} from "../public/path";
import PubSub from "pubsub-js"
import Store from "../store";

/**
 * 在线聊天
 * @author Yaochao
 * @date 2022/2/16 14:55
 * @description
 */
const {Sider, Header, Content} = Layout;
const ImServerUrl = process.env.REACT_APP_IMSERVER_URL;

// const ImChatMsgUrl = process.env.REACT_APP_CHAT_MSG_URL;
let timer = null
let myNotify;

class ImChat extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            wxid: '',
            chat_wxid: '',
            isRoom: null,//0：私聊，1：群聊
            list: {},
            userId: {},//用户Id
            chatData: '', //选中的聊天信息
            chatDataSelf: '', //选中的自己聊天信息

            leftSelect: {
                nickname: '',
                shortCorpName: '',
                avatar: '',
                lineStatus: 1, //在线1  离线2
                isOver: false,
            },
            // heartBeat:{},//心跳包
            userAvatar: 'http://wework.qpic.cn/bizmail/mZiaUqibZkdtAzr59ocrib13QLlc2tqqOj9xupE2Qkdtbibax8k4Lk8ibcg/0',
            isNeedSet: false, //是否需要设置，false不需要，true 需要
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        // console.log(this.props.location.search,nextProps.location.search,'dsdsdsdsd')
        if (nextProps.location.search) {
            this.setState({
                wxid: Util.getUrlArg('wxid'),
                chat_wxid: Util.getUrlArg('chat_wxid')
            })
        }
    }

    componentDidMount() {
        if (this.props.location.search) {
            this.setState({
                wxid: Util.getUrlArg('wxid'),
                chat_wxid: Util.getUrlArg('chat_wxid')
            })
        }
        this.initMyNotify();
        this.initWindowVisibilityListener();
        //进来先获取用户Id   userId
        CloudApi.getChatUserID((userId) => {
            this.setState({
                userId
            })
            this.socketConnect((socket) => {
                // console.log(socket, 'didmount')
                //获取对话框列表数据
                this.socket = socket;
                // console.log(this.socket)
                //设置用户信息
                this.setUserInfo(socket)

            });
        }, () => {
            // Message.error('用户Id获取失败')
        })
        //开始发送心跳
        this.handshake();
    }

    componentWillUnmount() {
        if (this.socket) {
            this.socket.disconnect();
        }
    }

    //初始化浏览器通知消息
    initMyNotify() {
        if (!myNotify) {
            myNotify = new MyNotify();
        }
    }

    //初始化页面离开或显示
    initWindowVisibilityListener() {
        let hiddenProperty = 'hidden' in document ? 'hidden' :
            'webkitHidden' in document ? 'webkitHidden' :
                'mozHidden' in document ? 'mozHidden' :
                    null;
        let visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
        let onVisibilityChange = function () {
            if (!document[hiddenProperty]) {
                //页面激活
                myNotify.enter();
                myNotify.stop();
            } else {
                //页面离开
                myNotify.leave();
            }
        };
        document.addEventListener(visibilityChangeEvent, onVisibilityChange);
    }

    handshake = () => {
        if (this.socket && this.socket.connected) {
            this.socket.emit('msgEvent', {
                type: IMMessageType.Beat,//类型
                data: {//用户Id
                    wxid: this.state.wxid,
                    chat_wxid: this.state.chat_wxid
                }
            })
        }
        setTimeout(this.handshake, 2000);
    };

    socketConnect(success) {
        const {leftSelect} = this.state
        // let socket = io('ws://192.168.1.112:9000');
        let socket = io(ImServerUrl);
        socket.on('connect', () => {
            //成功建立连接
            if (success) {
                success(socket)
            }
        });
        //消息监听
        socket.on('msgInfo', (msg) => {
            // console.log('心跳', msg.data, socket)
            if (msg.type == IMMessageType.AccountMsgNum) {//7012 账号消息数字
                // console.log('获取7012 账号消息数字', msg)
                this.wxAccountListRef ? this.wxAccountListRef.getMsgNum(msg) : ''
                this.roomRef ? this.roomRef.getTotal(msg) : ''
            }
            if (msg.type == IMMessageType.ConversationData) {//7001 获取对话框热数据
                // console.log('获取对话框裂变数据', msg)
                this.conversatIonListRef ? this.conversatIonListRef.newConversation(msg) : ''
            }
            if (msg.type == IMMessageType.SnapShotMsg) {//7009 消息快照
                this.conversatIonListRef ? this.conversatIonListRef.taskData(msg) : ''
            }
            if (msg.type == IMMessageType.BeatReturn) {//7006 心跳返回
                // console.log('心跳返回的数据', msg.data)
            }
            if (msg.type == IMMessageType.NewMsg) {//7008 新消息
                // console.log('9898新消息返回的数据', msg)
                this.roomRef ? this.roomRef.acceptNewMsg(msg) : ''
                // this.roomRef ? this.roomRef.receivingNewMessage(msg) : ''
                // this.chatSideRef ? this.chatSideRef.receivingNewMessage(msg) : ''
            }
            if (msg.type == IMMessageType.ApplyRecallResult) {//70011 撤回
                // let obj = {
                //     status: msg.data.status,
                //     msgId: msg.data.msgId,
                // }
                // this.roomRef ? this.roomRef.reCall(obj) : ''
            }
            if (msg.type == IMMessageType.UpdateRoomReturn) {//7014修改群名称返回
                // console.log('修改群昵称的数据', msg)
                this.conversatIonListRef && this.conversatIonListRef.modifyingGroupName(msg)
                if (msg.data.chat_wxid == Util.getUrlArg('chat_wxid')) {
                    let data = this.state.chatData
                    data.name = msg.data.roomName
                    this.chatData(data)
                }
            }
            if (msg.type == IMMessageType.RemoveMemberReturn) {//7015删除群成员
                // console.log('踢人的数据', msg)
                this.chatSideRef.kickingPlayer(msg)
            }
            if (msg.type == IMMessageType.LoginMsg) {//7019  登录
                // console.log(msg,'登录的id')
                this.wxAccountListRef.popUp(msg.data.wxid)//设置上线
            }
            if (msg.type == IMMessageType.LoginOut) {//7020  登出
                // console.log(msg,'登出的id')
                this.wxAccountListRef.heartBeatChange(msg.data.wxid)//设置离线
                const {leftSelect} = this.state
                leftSelect.isOver = true
                this.setState({leftSelect: leftSelect})
            }
            if (msg.type == IMMessageType.OPEN_CHAT) {//7021 打开聊天
                // console.log(msg.type, msg, '打开聊天的消息')
                this.wxAccountListRef.openChatMessageChange(msg.data.account)//打开聊天的消息
            }
            if (msg.type == IMMessageType.CLOSE_CHAT) {//7022 关不聊天的消息
                // console.log(msg.type, msg, '关闭聊天的消息')
                this.wxAccountListRef.closeChatMessageChange(msg.data.account)//关闭聊天的消息
            }
            if (msg.type == IMMessageType.Notice) {//7023 新消息提醒
                let data = msg.data;
                if (data && data.notDisturb != 1 && this.wxAccountListRef.isValidAccountFromServer(data.wxid)) {
                    myNotify.start();
                }
            }
            if (msg.type == IMMessageType.SendFail_Not_InRoom) {//7016 不在群里
                Message.error('您不在该群，无法发送消息！')
            }
            if (msg.type == IMMessageType.SendFail_Not_Friend) {//7018 不是好友
                Message.error('您与对方不是好友关系，无法发送消息！')
            }
            if (msg.type == IMMessageType.MSG_SUCCESS) {//7025 发送成功
                // console.log('9898msg', msg)
            }
        })
        //监听socket重连
        socket.on("reconnect", (attempt) => {
            // console.log(attempt, this.socket, '重连')
            CloudApi.getChatUserID((userId) => {
                this.setState({
                    userId
                })
                //设置用户信息
                this.setUserInfo(this.socket)
                //设置Wxid
                this.setCurrentWxid(this.socket)
                //设置当前会话
                this.setCurrentKey(this.socket)
            }, () => {
                // Message.error('用户Id获取失败')
            })
            //开始发送心跳
            this.handshake();
        });


        //成功连接  socket.on('connect',(msg)=>{})
        //消息监听  socket.on('msgInfo',(msg)=>{})
        //重新连接  socket.on('reconnect',(msg)=>{})
        //断开连接  socket.on('disconnect',(msg)=>{})
    }

    //设置用户信息
    setUserInfo = (socket) => {
        socket.emit('bind', {
            type: IMMessageType.BindUser,//类型
            data: this.state.userId//用户Id
        })
    }
    //设置wxid
    setCurrentWxid = (socket) => {
        if (this.socket) {
            socket.emit('msgEvent', {
                type: IMMessageType.SetCurrentWxId,
                data: {
                    wxid: this.state.wxid,
                },
            })
        }
    }
    //设置当前会话
    setCurrentKey = (socket) => {
        if (socket) {
            socket.emit('msgEvent', {
                type: IMMessageType.SetCurrentChatKey,//类型
                data: {//用户Id
                    wxid: this.state.wxid,
                    chat_wxid: this.state.chat_wxid
                }
            })
        }
    }

    //抛出 发消息socket
    outSocket = (contents, msgSendId) => {
        if (this.socket && this.socket.connected) {
            this.socket.emit('msgEvent', {
                type: IMMessageType.SendMessage,//类型
                data: {//用户Id
                    wxid: this.state.wxid,
                    chat_wxid: this.state.chat_wxid,
                    contents: contents,
                    senderId: this.state.wxid,
                    msgSendId: msgSendId,
                },
            })
            console.log('发送消息data：', {
                wxid: this.state.wxid,
                chat_wxid: this.state.chat_wxid,
                contents: contents,
                senderId: this.state.wxid,
                msgSendId: msgSendId,
            })
        }
    }

    //抛出 撤回消息socket
    reCallSocket = (contents) => {
        if (this.socket && this.socket.connected) {
            this.socket.emit('msgEvent', {
                type: IMMessageType.ApplyRecallMsg,//类型
                data: {
                    wxid: this.state.wxid,
                    msgId: contents.msgId
                }
            })
        }
    }

    reSendSocket = (contents, msgSendId) => {
        if (this.socket && this.socket.connected) {
            this.socket.emit('msgEvent', {
                type: IMMessageType.RESEND,//类型
                data: {//用户Id
                    wxid: this.state.wxid,
                    chat_wxid: this.state.chat_wxid,
                    contents: contents,
                    senderId: this.state.wxid,
                    msgSendId: msgSendId,
                },
            })
        }
    }

    //获取左侧的联系人id
    accountChange = (list) => {
        //设置 当前选中的账号信息
        if (list == undefined) return
        this.setState({
            leftSelect: {
                ...list,
                nickname: list.nickname,
                shortCorpName: list.shortCorpName,
                avatar: list.avatar,
                lineStatus: list.status,
                isOver: true,
            }
        })
        let wxid = list.wxid
        if (list.wxid != this.state.wxid) {
            this.props.history.replace(Util.stitchingPath('/im/chat', {
                wxid: list.wxid
            }))
        }
        this.setState({
            wxid,
            chat_wxid: ''
        }, () => {
            if (this.socket) {
                this.setCurrentWxid(this.socket)
            } else {
                //等待socket
                setTimeout(() => {
                    this.setCurrentWxid(this.socket)
                }, 1000)
            }
        })
        this.chatDataSelf(list)
    }

    //获取聊天的内容
    getContent = (list) => {
        let chat_wxid = list.chat_wxid
        this.setState({
            chat_wxid,
            isRoom: list.isRoom
        }, () => {
            if (this.socket) {
                this.setCurrentKey(this.socket)
            } else {
                setTimeout(() => {
                    this.setCurrentKey(this.socket)
                }, 1500)
            }
        })
        this.props.history.replace(Util.stitchingPath('/im/chat', {
            wxid: this.state.wxid,
            chat_wxid: chat_wxid
        }))
        this.chatData(list)
    }

    aFold = () => {
        this.setState({
            collapsed: !this.state.collapsed
        })
    }

    //get对方聊天信息
    chatData = (obj) => {
        this.setState({
            chatData: obj
        })
    }

    //get 自己的聊天信息
    chatDataSelf = obj => {
        this.setState({
            chatDataSelf: obj
        })
    }
    //展开联系人
    unfoldLinkMan = () => {
        if (this.state.collapsed == true) {
            this.setState({
                collapsed: false
            })
        }
    }

    nextUnRead = () => {
        try {
            if (this.conversatIonListRef) {
                this.conversatIonListRef.nextUnread();
            }
        } catch (e) {
            // console.log(e)
        }
    };

    exit() {
        CorpApi.userExit(() => {
            this.props.history.push(Path.getSigninPath('zkcloud'))
        });
    }

    /**
     * boolean, 传 true  false
     * @param boolean
     */
    setNeed = (boolean) => {
        // console.log(boolean, 'chat')
        this.setState({isNeedSet: boolean})
    }

    render() {
        const {
            collapsed,
            wxid,
            chat_wxid,
            chatData,
            chatDataSelf,
            qrcodeUrl,
            status,
            leftSelect,
            isNeedSet
        } = this.state
        return (
            <Layout className='im-layout'>
                <Sider className='im-sider' width={250} collapsed={collapsed} collapsedWidth={74}>
                    <WxwAccountList ref={r => this.wxAccountListRef = r}
                                    wxid={this.state.wxid} collapsed={collapsed}
                                    setNeed={this.setNeed}
                        // msgMum={this.msgNum.bind(this)}
                                    unfoldLinkMan={this.unfoldLinkMan}
                                    onChange={this.accountChange.bind(this)} aFold={this.aFold}/>
                </Sider>
                <Layout>
                    <Header className="im-header">
                        <div className='im-panel'>
                            <span className={'btn'} onClick={this.aFold}>
                                            {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined)}
                            </span>
                            <TopEdit getData={this.wxAccountListRef ? this.wxAccountListRef.getData : null}
                                     queryLinkMan={this.wxAccountListRef ? this.wxAccountListRef.queryLinkMan : null}
                                     ref={r => this.topEditRef = r}
                            />
                        </div>
                        <ul className='qy-header-colummenu'>
                            <li><a href='https://ee3z2ep36h.feishu.cn/docs/doccn1cIp2T9RHlIOEM02bFJKT3'
                                   target='_blank'><IconAccountHelp/><span>帮助</span></a></li>
                            <li onClick={this.exit.bind(this)}><IconAccountExit/><span>退出</span>
                            </li>
                        </ul>
                    </Header>
                    {
                        //新用户
                        !isNeedSet ?
                            //在线部分
                            <Content className="im-content">
                                {
                                    leftSelect.isOver ?
                                        <ConversationList ref={r => this.conversatIonListRef = r}
                                                          fProps={this.props}
                                                          getContent={this.getContent.bind(this)} wxid={this.state.wxid}
                                                          chat_wxid={this.state.chat_wxid}
                                                          getChatAvatar={(value) => this.getChatAvatar(value)}
                                        /> : ''
                                }
                                {
                                    leftSelect.isOver && Util.getUrlArg('chat_wxid') ?
                                        <>
                                            <ChatRoom wxid={wxid} chat_wxid={Util.getUrlArg('chat_wxid')}
                                                      ref={r => this.roomRef = r}
                                                      chatData={chatData} //左侧聊天数据
                                                      chatDataSelf={chatDataSelf} //右侧聊天数据
                                                      outSocket={this.outSocket}
                                                      reCallSocket={this.reCallSocket}
                                                      reSendSocket={this.reSendSocket}
                                                // unReadNum={this.conversatIonListRef ? this.conversatIonListRef.getTotal() : 0}
                                                      nextUnRead={this.nextUnRead}
                                                      endConversation={this.conversatIonListRef ? this.conversatIonListRef.endSession : ''}
                                                      leftSelect={leftSelect}
                                                      leftUpdate={this.wxAccountListRef ? this.wxAccountListRef.getData : null}
                                            />
                                            <ChatSider isRoom={this.state.isRoom} wxid={this.state.wxid}
                                                       ref={r => this.chatSideRef = r}
                                                       leftSelect={leftSelect}
                                                       chatData={chatData} //左侧聊天数据
                                                       talklibSend={this.roomRef ? this.roomRef.talklibSend : ''} //左侧聊天数据
                                                       chat_wxid={this.state.chat_wxid}/>
                                        </>
                                        :
                                        <div className={'im-empty-chat'}>
                                            <img src={empty_chat}/>
                                            <p>{'— 暂无聊天消息 —'}</p>
                                        </div>
                                }
                            </Content>
                            :
                            // 第一版离线部分，勿删
                            <div className={'im-outLine-max'}>
                                <ImLogin ref={r => this.imLoginRef = r} data={leftSelect} wxid={wxid}
                                         afterSuccess={this.wxAccountListRef ? this.wxAccountListRef.getData : null}></ImLogin>
                                <div className={'im-login'}>
                                    <img src={imBlank}/>
                                    <p>{'请先开启账号在线聊天功能'}</p>
                                    <Button onClick={() => this.topEditRef.chatSetting()} type="primary" shape="round"
                                            style={{width: '260px'}}
                                            size={'large'}>
                                        前往设置
                                    </Button>
                                </div>
                            </div>
                    }
                </Layout>
                {/*<MonitorRoute/>*/}
            </Layout>
        );
    }
}

export default withRouter(ImChat)